var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('span', {
    staticClass: "omnistock omni-button-collection",
    class: _vm.computedClassNames
  }, [_vm._t("default")], 2);

}
var staticRenderFns = []

export { render, staticRenderFns }